/* eslint-disable @typescript-eslint/no-explicit-any */
let getAccessTokenSilently: any = null;

export const security = {
  getAccessTokenSilently: () => getAccessTokenSilently,
  setAccessTokenSilently: (func: any) => (getAccessTokenSilently = func),
};
